import { ReceiptDetailDto } from "../../../store/models/CustomerInteractionDto";

type ReceiptExampleItemInfoParams = {
  productGroupNumber: number;
  productGroupDesc: string;
  subGroupNumber: number;
  subGroupDesc: string;
  supplierNumber: number;
  supplierDesc: string;
  supplierItemText: string;
  refNumber: string;
  rating: number;
  votings: number;
  organic: boolean;
  ean: string;
};

type ReceiptExampleParams = {
  amount: string;
  salesPrice: string;
  originalPrice: string;
  itemInfo: ReceiptExampleItemInfoParams;
};

export const createReceiptExample = ({
  amount,
  salesPrice,
  originalPrice,
  itemInfo,
}: ReceiptExampleParams): ReceiptDetailDto => ({
  amount,
  salesPrice,
  originalPrice,
  itemInfo: {
    ...itemInfo,
    salesAreaNumber: 123,
    salesAreaDesc: "salesAreaDesc",
  },
});
